import { ActivityCard, ItineraryItem } from "./ActivityCard";

interface DaySectionProps {
  dayNumber: number;
  date: Date | null;
  items: ItineraryItem[];
}

/**
 * Format a UTC Date object to display the correct date in any timezone.
 * The date was created with Date.UTC() so we must read it back in UTC.
 */
function formatUTCDate(date: Date): string {
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'long',
    day: '2-digit',
    timeZone: 'UTC'
  }).format(date);
}

export function DaySection({ dayNumber, date, items }: DaySectionProps) {
  return (
    <div 
      className={`rounded-lg overflow-hidden ${
        dayNumber % 2 === 1 ? 'bg-muted/30' : 'bg-background border'
      }`}
    >
      {/* Day Header */}
      <div className="bg-secondary text-secondary-foreground px-6 py-4">
        <h3 className="text-xl font-bold">Day {dayNumber}</h3>
        {date && (
          <p className="text-secondary-foreground/80 text-sm">
            {formatUTCDate(date)}
          </p>
        )}
      </div>
      
      {/* Day's Activities */}
      <div className="p-4 space-y-4">
        {items.map((item) => (
          <ActivityCard key={item.id} item={item} />
        ))}
      </div>
    </div>
  );
}
